<script>
export default {
  data: () => ({
    activeTab: "Generators",
  }),
};
</script>

<template>
  <!-- <v-container> -->
  <v-bottom-navigation
    mandatory
    fixed
    app
    v-model="activeTab"
    color="primary"
    @click="$emit('change', activeTab)"
  >
    <v-btn value="Generators">
      <v-icon>mdi-wrench</v-icon>
      <span>Generators</span>
    </v-btn>
    <v-btn value="Palettes">
      <v-icon>mdi-palette</v-icon>
      <span>Palettes</span>
    </v-btn>
    <v-btn value="Settings">
      <v-icon>mdi-cog</v-icon>
      <span>Settings</span>
    </v-btn>
  </v-bottom-navigation>
  <!-- </v-container> -->
</template>